import _ from 'lodash';

export const NAME = 'profilePage';
export default function profile(state = {}, action) {
    switch (action.type) {
        case 'PROFILE_USER__FETCH_SUCCESS':
            const { user, organization } = action.payload;
            return {
                ...state,
                user: {
                    id: user.id,
                    attr: user,
                    etag: user._etag,
                },
                organization: {
                    id: organization.id,
                    attr: organization,
                },
            };
        case 'PROFILE_USER__FETCH_FAIL':
            const payload = _.get(action, 'payload', void 0);
            return {
                ...state,
                showUsersError: payload.err.message,
            };

        case 'PROFILE_PAGE__UPDATE_EMAIL_SUBSCRIPTION_PREFERENCES_START':
            return {
                ...state,
                isUpdatingPreferences: true,
            };
        case 'PROFILE_PAGE__UPDATE_EMAIL_SUBSCRIPTION_PREFERENCES_SUCCESS':
            return {
                ...state,
                isUpdatingPreferences: false,
                user: {
                    ...state.user,
                    attr: action.payload.user,
                    etag: action.payload.user._etag || state.user.etag,
                },
            };
        case 'PROFILE_PAGE__UPDATE_EMAIL_SUBSCRIPTION_PREFERENCES_FAIL': {
            return {
                ...state,
                isUpdatingPreferences: false,
            };
        }
        case 'PROFILE_PAGE__UPDATE_NEW_REPORTING_PREFERENCE_START':
            return {
                ...state,
                isUpdatingPreferences: true,
            };
        case 'PROFILE_PAGE__UPDATE_NEW_REPORTING_PREFERENCE_SUCCESS':
            return {
                ...state,
                isUpdatingPreferences: false,
                user: {
                    ...state.user,
                    attr: action.payload.user,
                    // Next preference save must send this If-Match, not the pre-save etag.
                    etag: action.payload.user._etag || state.user.etag,
                },
            };
        case 'PROFILE_PAGE__UPDATE_NEW_REPORTING_PREFERENCE_FAIL':
            return {
                ...state,
                isUpdatingPreferences: false,
            };
        default:
            return state;
    }
}
